<template>
    <v-card v-if="hasSchema()">
        <div v-for="(username, id, i) in getUsers()" :key="id">
            <br />
            <pre>{{ username }}</pre>
            <br />
            <v-data-table
                :headers="getHeaders()"
                :items="getItems(id)"
                :footer-props="{
                    'items-per-page-options': [-1],
                    showFirstLastPage: true,
                }"
                item-key="_id"
                class="elevation-1"
                dense
                @click:row="open"
            >
            </v-data-table>
        </div>

        <div v-if="hasMissions() && getMissions().length">
            <br />
            <pre>Missions</pre>
            <br />
            <v-data-table
                :headers="getHeaders()"
                :items="getMissions()"
                :footer-props="{
                    'items-per-page-options': [-1],
                    showFirstLastPage: true,
                }"
                item-key="_id"
                class="elevation-1"
                dense
                @click:row="openMission"
            >
            </v-data-table>
        </div>

        <database-document-dialog :db="db" :document="document" v-model="dialog" :key="key" />
        <database-document-dialog db="missions" :document="missionDocument" v-model="missionDialog" :key="'mission-' + missionKey" />
    </v-card>
</template>

<script>
import DatabaseDocumentDialog from "@/database-components/database-document-dialog.vue";

import exchanger from "@/database-components/database-exchanger.js";

const userFilter = (data = [], id) =>
    data.filter((d) => {
        return d.user === id;
    });

const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Budapest",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
});

const toDate = (d) => formatter.format(d instanceof Date ? d : new Date(d));

export default {
    name: "MonthlyClose",
    components: { DatabaseDocumentDialog },
    data() {
        return {
            document: null,
            dialog: false,
            selected: [],
            key: 0,
            db: "eventlog",
            cached: null,
            cachedMissions: null,
            missionDocument: null,
            missionDialog: false,
            missionKey: 0,
        };
    },
    route: {
        path: "/monthly-close",
        icon: "mdi-calendar-check",
        toolbar: true,
        sidebar: true,
        homepage: false,
        usecase: "monthlyclose",
        open: "/monthly-close",
    },
    methods: {
        hasSchema() {
            if (this.$store.getters["database/getDatabaseFormat"](this.db)) return true;
            return false;
        },
        monthRange() {
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0);
            const end = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
            return { start, end };
        },
        filterByMonth(data) {
            const { start, end } = this.monthRange();
            return (data || []).filter((it) => {
                const iso = it.date || it.createdAt;
                if (!iso) return false;
                const d = new Date(iso);
                return d >= start && d <= end;
            });
        },
        getData() {
            if (this.cached) return this.cached;
            const data = this.$store.getters["database/getDatabaseArrayData"](this.db);
            this.cached = this.filterByMonth(data);
            return this.cached;
        },
        getUserName(id) {
            const users = this.$store.state.database.users.data || {};
            const doc = users[id] || {};
            return doc.name || id;
        },
        getHeaders() {
            //const format = this.$store.getters["database/getDatabaseFormat"](this.db);
            //const headers = headersByFormat(format);
            /*
{text: 'Eventlog', value: 'name'}
{text: 'Start', value: 'date'}
{text: 'Location', value: 'location'}
{text: 'Mission', value: 'mission'}
{text: 'User', value: 'user'}
{text: 'Aktivity', value: 'activity'}
{text: 'Assets', value: 'assets'}
{text: 'Photos', value: 'photos'}
{text: 'Comments', value: 'comment'}
          */
            const headers = [
                { text: "Start", value: "date" },
                { text: "Activity", value: "activity" },
                { text: "Location", value: "location" },
                { text: "Comments", value: "comment" },
                { text: "Workhours", value: "workhours" },
                { text: "Payment", value: "payment" },
                { text: "Assets", value: "assets" },
            ];
            console.log(headers);
            return headers;
        },
        getUsers() {
            //const data = this.$store.getters["database/getDatabaseArrayData"](this.db);
            const data = this.getData();
            const UserItems = {};
            for (const item of data) {
                const id = item.user;
                if (!UserItems[id]) UserItems[id] = this.getUserName(id);
            }
            return UserItems;
        },
        getItems(id) {
            //const data = this.$store.getters["database/getDatabaseArrayData"](this.db);
            //const items = exchanger(userFilter(dateFilter(data), id), this, true);
            const data = this.getData();
            const items = exchanger(userFilter(data, id), this, true);
            console.log(items);

            items.forEach((item) => (item.workhours = 0));

            let starter = null;
            for (const item of items) {
                if (item.activity === "Munka-kezdés") {
                    starter = new Date(item.date);
                }
                if (item.activity === "Munka-végzés") {
                    const endTime = new Date(item.date);
                    const milliseconds = endTime - starter;
                    const hours = milliseconds / (1000 * 60 * 60);
                    item.workhours = Math.round(hours);
                }
            }

            items.forEach((item) => (item.payment = 0));

            items.forEach((item) => (item.date = toDate(item.date)));
            return items;
        },
        hasMissions() {
            if (this.$store.getters["database/getDatabaseFormat"]("missions")) return true;
            return false;
        },
        getMissionData() {
            if (this.cachedMissions) return this.cachedMissions;
            const data = this.$store.getters["database/getDatabaseArrayData"]("missions");
            this.cachedMissions = this.filterByMonth(data);
            return this.cachedMissions;
        },
        getMissions() {
            // exchange ref ids (location, ...) to names using the missions format
            const items = exchanger(this.getMissionData(), { db: "missions", $store: this.$store }, true);
            return items.map((m) => ({
                _id: m._id,
                date: toDate(m.date),
                activity: "mission",
                location: m.location,
                comment: m.name, // mission name
                workhours: Math.round((m.duration || 0) / 3600), // duration hours
                payment: 0,
                assets: m.comment, // the comment
            }));
        },
        openMission(t) {
            const id = t._id;
            if (id) this.missionDocument = this.$store.state.database.missions.data[id];
            else this.missionDocument = {};
            this.missionKey++;
            this.missionDialog = true;
        },
        open(t, i) {
            //console.log("Database table open:", t, i, this.items[i.index].name);
            const id = t._id;
            if (id) this.document = this.$store.state.database[this.db].data[id];
            else this.document = {};
            this.key++;
            this.dialog = true;
        },
    },
};
</script>

<!--template>
    <v-card v-if="hasSchema()">
        <database-table db="eventlog" :items="filter()" key="eventlog" />
        <database-dialog-table db="eventlog" :items="filter()" key="eventlog" />
    </v-card>
</template>

<script>
import DatabaseTable from "@/database-components/database-table.vue";
import DatabaseDialogTable from "@/database-components/database-dialog-table.vue";

export default {
    name: "MonthlyClose",
    components: { DatabaseTable, DatabaseDialogTable },
    data() {
        return {
            dialog: true,
        };
    },
    route: {
        path: "/monthly-close",
        icon: "mdi-calendar-check",
        toolbar: true,
        sidebar: true,
        homepage: false,
        usecase: "monthlyclose",
        open: "/monthly-close",
    },
    methods: {
        hasSchema() {
            if (this.$store.getters["database/getDatabaseFormat"]("eventlog")) return true;
            return false;
        },
        filter() {
            const data = this.$store.getters["database/getDatabaseArrayData"]("eventlog");
            if (!data) return [];
            return data;
        },
    },
};
</script-->
